import { BackendModel, BackendService } from "../../core/backend.service";

export class CodigoPromocion extends BackendModel {

  id: number;
  porcentajeDescuento: number; 
  codigo:string;
  nombreObjeto:string;
  categoriaId: number;
  productoId: number;
  etiqueta:string;
  fechaDesde: Date | 'dd/MM/yyyy';
  fechaHasta: Date | 'dd/MM/yyyy';
  

  constructor(protected backendService: BackendService, model?: CodigoPromocion) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/pedido/codigos-promocion/codigo-promocion.model.ts